import {PropertyTypeConstructor} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ErrorOrEmpty} from '@mintdata/mint-kit/api/types/Value';
import {ABinaryData} from '@mintdata/mint-kit/api/values/ABinaryData';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AByte} from '@mintdata/mint-kit/api/values/AByte';
import {ACurrency} from '@mintdata/mint-kit/api/values/ACurrency';
import {ADate} from '@mintdata/mint-kit/api/values/ADate';
import {AEmpty} from '@mintdata/mint-kit/api/values/AEmpty';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';
import {ATime} from '@mintdata/mint-kit/api/values/ATime';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {Frames} from '@mintdata/mint-kit/api/values/frames/Frames';
import {BaseCoercionUtil} from '@mintdata/mint-kit/impl/coercionUtils/BaseCoercionUtil';
import {JsonUtil} from '@mintdata/mint-kit/impl/util/JsonUtil';

declare const TextEncoder:any;

export class StringCoercionUtil extends BaseCoercionUtil
{
    constructor()
    {
        super(Type.String);
    }

    public toBoolean(from:AString):ABoolean | ErrorOrEmpty
    {
        return new ABoolean(from.value != null && from.value.length > 0);
    }

    public toByte(from:AString):AByte | ErrorOrEmpty
    {
        if( !this._checkIfNumber(from) )
            return super.toByte(from);

        const aByte:number = Math.floor(parseFloat(from.value));

        if( isNaN(aByte) )
            return super.toByte(from);

        return new AByte(aByte);
    }

    toBinaryData(from:AString):ABinaryData | ErrorOrEmpty
    {
        return new ABinaryData(
            new TextEncoder().encode(from.value)
        );
    }

    public toCurrency(from:AString):ACurrency | ErrorOrEmpty
    {
        if( !this._checkIfNumber(from) )
            return super.toCurrency(from);

        const aCurrency:number = parseFloat(from.value);

        if( isNaN(aCurrency) )
            return super.toCurrency(from);

        return new ACurrency(aCurrency);
    }

    public toDate(from:AString):ADate | ErrorOrEmpty
    {
        return ADate.fromString(from.value);
    }

    public toTime(from:AString):ATime | ErrorOrEmpty
    {
        if( from.isEqualTo(AString.fromString('')) )
            return AEmpty.Value;

        return ATime.fromString(from.value);
    }

    // public toDateTime(from:AString):ADateTime | ErrorOrEmpty
    // {
    // 	const result = Date.parse(from.value);
    //
    // 	if( isNaN(result) )
    // 		return super.toDateTime(from);
    //
    // 	const date = new Date(result);
    //
    // 	return new ADateTime(
    // 		date.getFullYear(),
    // 		date.getMonth(),
    // 		date.getDate(),
    // 		date.getHours(),
    // 		date.getMinutes(),
    // 		date.getSeconds(),
    // 	);
    // }

    // public  toEnum(from:AString):AEnum | ErrorOrEmpty
    // {
    // 	throw new Error('Method not implemented.');
    // }

    public toInteger(from:AString):AInteger | ErrorOrEmpty
    {
        if( !this._checkIfNumber(from) )
            return super.toInteger(from);

        const aInteger:number = Math.floor(parseFloat(from.value));

        if( isNaN(aInteger) )
            return super.toInteger(from);

        return new AInteger(aInteger);
    }

    public toNumber(from:AString):ANumber | ErrorOrEmpty
    {
        if( !this._checkIfNumber(from) )
            return super.toNumber(from);

        const aNumber:number = parseFloat(from.value);

        if( isNaN(aNumber) )
            return super.toNumber(from);

        return new ANumber(aNumber);
    }

    public toStringEnum(from:AString, toCtor?:PropertyTypeConstructor<any>):AStringEnum | ErrorOrEmpty
    {
        const toValue:AStringEnum = (new toCtor()) as AStringEnum;
        return new AStringEnum(from, toValue.values);
    }

    public toFrame(from:AString):IFrame | ErrorOrEmpty
    {
        try
        {
            const jsObject = JSON.parse(from.value);
            return Frames.fromJSONObject(jsObject);
        }
        catch( e )
        {
            return JsonUtil.convertJsonObjectToFrame(from.value);
        }
    }

    private _checkIfNumber(value:AString):boolean
    {
        return /^[+-]?\d*(\.\d+)?$/.test(value.value.trim())
            || /^[+-]?\d+(\.\d*)?$/.test(value.value.trim());
    }
}
